import { perPage } from "@temp/constants";
import * as React from "react";
import Media from "react-responsive";
import { useParams } from "react-router-dom";
import { Footer, MainMenu, SearchHeaderDesktop } from "@temp/components";
import { xMediumScreen } from "@styles/constants";
import { useAppSelector } from "@temp/redux";
import { TypedSubCategoryProducts } from "./queries";
import SubCategoryContent from "./SubCategoryContent";
var PRODUCTS_PER_PAGE = +perPage;
export var viewGeneral = function viewGeneral() {
  var _useParams = useParams(),
      id = _useParams.id,
      redirect = _useParams.redirect,
      redirectHome = _useParams.redirectHome;

  var _useAppSelector = useAppSelector(function (store) {
    return store;
  }),
      searchQueryValue = _useAppSelector.search.searchQueryValue;

  var redirectView = redirect && true;
  var redirectHomeView = redirectHome && true;
  return React.createElement(React.Fragment, null, redirectView && redirectHomeView ? React.createElement(MainMenu, {
    search: true,
    cart: true
  }) : redirectView && !redirectHomeView ? React.createElement(MainMenu, {
    gobackSubCategoriesCategory: true,
    search: true,
    cart: true
  }) : React.createElement(MainMenu, {
    gobackCategoriesSale: true,
    search: true,
    cart: true
  }), React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(SearchHeaderDesktop, {
    subCategory: true,
    redirect: redirectView,
    redirectHome: redirectHomeView
  })), React.createElement(TypedSubCategoryProducts, {
    fetchPolicy: "".concat(localStorage.getItem("scroll-product") ? "cache-first" : "cache-and-network"),
    variables: {
      perPage: PRODUCTS_PER_PAGE,
      subCategoryId: +id,
      search: searchQueryValue
    }
  }, function (_ref) {
    var data = _ref.data,
        loading = _ref.loading,
        loadMore = _ref.loadMore;
    return React.createElement(SubCategoryContent, {
      data: data.subCategoryProductsLoadMore,
      loading: loading,
      loadMore: loadMore
    });
  }), redirectView && redirectHomeView && React.createElement(Footer, null), React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(Footer, null)));
};
export default viewGeneral;